import type { IFieldDefinition, IRecordTypeDefinition } from '@platform/core/types';

/** Визначення полів для колонок списку (без title — він завжди окрема колонка; без прихованих полів визначення — їх не показують ніде). */
export function fieldsForColumns(rt: IRecordTypeDefinition, columns: string[]): IFieldDefinition[] {
  return columns.map((c) => rt.fields.find((f) => f.key === c)).filter((f): f is IFieldDefinition => Boolean(f) && f!.key !== 'title' && !f!.hidden);
}

/**
 * Поля стовпців таблиці (UIUX tables/columns; прототип v4 allDef — усі inTable, зокрема довгий текст: він бере участь у розкладці за шириною
 * й у примітці «Приховано стовпців»): колонки списку без назви й JSON — JSON стовпцем не буває.
 */
export function tableFieldsOf(rt: IRecordTypeDefinition, columns: string[]): IFieldDefinition[] {
  return fieldsForColumns(rt, columns).filter((f) => f.type !== 'json');
}
